export const JSON_PANEL_HEIGHT = "calc(100dvh - 400px)";
